import { render, staticRenderFns } from "./CurrentUser.vue?vue&type=template&id=f8b4eb84&scoped=true&lang=pug&"
import script from "./CurrentUser.vue?vue&type=script&lang=js&"
export * from "./CurrentUser.vue?vue&type=script&lang=js&"
import style0 from "./CurrentUser.vue?vue&type=style&index=0&id=f8b4eb84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b4eb84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8b4eb84')) {
      api.createRecord('f8b4eb84', component.options)
    } else {
      api.reload('f8b4eb84', component.options)
    }
    module.hot.accept("./CurrentUser.vue?vue&type=template&id=f8b4eb84&scoped=true&lang=pug&", function () {
      api.rerender('f8b4eb84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/virtualrow/CurrentUser.vue"
export default component.exports